import { Injectable } from '@angular/core';
import { LocalizedCommon } from '@shared/services/common/models';
import { StoreBase } from '@stores/abstract';

@Injectable({ providedIn: 'root' })
export class LocalizedCommonStore extends StoreBase<LocalizedCommon> {
  override storeName = 'LocalizedCommonStore';
}
